export const formApi = {
  feedback: 'feedback',
  footer_feedback: 'footer-feedback',
  subscription: 'subscription',
  consultation: 'consultation',
  test_drive: 'test-drive',
  service: 'service',
  drive2u: 'drive2u',
  parts: 'parts',
  credit: 'credit',
  leasing: 'leasing',
  insurance: 'insurance',
  assistance: 'assistance',
  corporate_clients: 'corporate-clients',
  producing: 'producing',
  fuel_card: 'fuel-card',
  export: 'export',
  customs: 'customs',
  transport: 'transport',
  carrier: 'carrier',
  job: 'job',
  autocenter_application: 'autocenter',
  autoservice: 'autoservice',
  maintenance_calculator: 'regular-maintenance-calculator',
  services_calculator: 'price-services-calculator',
};
